import { CarsPage } from "@/pages/Catalog";
export default CarsPage;
